import {
	AfterContentChecked,
	ChangeDetectorRef,
	Component,
	Input,
	ViewEncapsulation,
} from '@angular/core';

@Component({
	selector: 'promptuary-quality-description',
	templateUrl: './promptuary-quality-description.component.html',
	encapsulation: ViewEncapsulation.None,
})
export class PromptuaryQualityDescription implements AfterContentChecked {
	@Input() isOpen: boolean;

	constructor(public changeDetectorReference: ChangeDetectorRef) {}

	ngAfterContentChecked() {
		this.changeDetectorReference.detectChanges();
	}
}
